import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let appSurveyOptions = [];
let frequencyOptions = [];
let dayOfWeekOptions = [];
function UserAppSurveyAlertTableRow({ index, appSurveyNames, handleSubmit, setError, t, setAdd, oddIdx }) {
    const [appSurveyLoaded, setAppSurveyLoaded] = useState(false);
    const [appSurveySelected, setAppSurveySelected] = useState({ name: "appSurveyKey", label: "", value: 0 });
    const notCompletedRef = useRef(null);
    const [isNotCompleted, setIsNotCompleted] = useState(false);
    const completedRef = useRef(null);
    const [isCompleted, setIsCompleted] = useState(false);
    const highScoreRef = useRef(null);
    const [isHighScore, setIsHighScore] = useState(false);
    const freqRef = useRef(null);
    const [frequencySelected, setFrequencySelected] = useState({ name: "freq", label: "", value: "" });
    const dowRef = useRef(null);
    const [dayOfWeekSelected, setDayOfWeekSelected] = useState({ name: "dow", label: t("page.anyday"), value: 0 });
    const takeCorrectiveActionRef = useRef(null);
    const [isTakeCorrectiveAction, setIsTakeCorrectiveAction] = useState(false);
    const completeCorrectiveActionRef = useRef(null);
    const [isCompleteCorrectiveAction, setIsCompleteCorrectiveAction] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        setFrequencyValues();
        setDayOfWeekValues();
        setAppSurveyValues(appSurveyNames);
    }, []);

    function setAppSurveyValues(appSurveyObj) {
        let appSurveyValue = {};
        appSurveyOptions = [];
        if (appSurveyObj && appSurveyObj.length > 0) {
            appSurveyObj.map((aAppSurvey, idx) => {

                appSurveyValue.label = aAppSurvey.surveyDisplayName;
                appSurveyValue.value = aAppSurvey.appSurveyKey;
                appSurveyOptions.push(appSurveyValue);
                if (idx == 0) {
                    setAppSurveySelected({ ...appSurveySelected, label: appSurveyValue.label, value: aAppSurvey.appSurveyKey });
                }
                appSurveyValue = {};
            });
            setAppSurveyLoaded(true);
        }
    }

    function setFrequencyValues() {
        frequencyOptions = [];
        frequencyOptions.push({ "label": "", "value": "" });
        frequencyOptions.push({ "label": t("page.weekly"), "value": "week" });
        frequencyOptions.push({ "label": t("page.monthly"), "value": "month" });
        frequencyOptions.push({ "label": t("page.yearly"), "value": "year" });
    }

    const appSurveyHandler = (selectedOption, action) => {
        let appSurveyKey = selectedOption ? selectedOption.value : 0;
        let appSurveyLabel = selectedOption ? selectedOption.label : "";
        setAppSurveySelected({ ...appSurveySelected, label: appSurveyLabel, value: appSurveyKey });
    }

    const freqHandler = (selectedOption, action) => {
        let freqValue = selectedOption ? selectedOption.value : 0;
        let freqLabel = selectedOption ? selectedOption.label : "";
        setFrequencySelected({ ...frequencySelected, label: freqLabel, value: freqValue });
    }
    function setDayOfWeekValues() {
        dayOfWeekOptions = [];
        dayOfWeekOptions.push({ "label": t("page.anyday"), "value": 0 });
        dayOfWeekOptions.push({ "label": t("page.mon"), "value": 2 });
        dayOfWeekOptions.push({ "label": t("page.tue"), "value": 3 });
        dayOfWeekOptions.push({ "label": t("page.wed"), "value": 4 });
        dayOfWeekOptions.push({ "label": t("page.thu"), "value": 5 });
        dayOfWeekOptions.push({ "label": t("page.fri"), "value": 6 });
        dayOfWeekOptions.push({ "label": t("page.sat"), "value": 7 });
        dayOfWeekOptions.push({ "label": t("page.sun"), "value": 1 });
    }

    const dayOfWeekHandler = (selectedOption, action) => {
        let dowSelectValue = selectedOption ? selectedOption.value : 0;
        let dowSelectLabel = selectedOption ? selectedOption.label : t("page.anyday");
        setDayOfWeekSelected({ ...dayOfWeekSelected, label: dowSelectLabel, value: dowSelectValue });
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("notCompleted_")) {
            setIsNotCompleted(event.target.checked);
        } else if (name.startsWith("completed_")) {
            setIsCompleted(event.target.checked);
        } else if (name.startsWith("highScore_")) {
            setIsHighScore(event.target.checked);
        } else if (name.startsWith("completeCorrectiveAction_")) {
            setIsCompleteCorrectiveAction(event.target.checked);
        } else if (name.startsWith("takeCorrectiveAction_")) {
            setIsTakeCorrectiveAction(event.target.checked);
        }
    }

    function submitComplete() {
        setIsSubmit(false);
        setIsNotCompleted(false);
        setIsCompleted(false);
        setIsHighScore(false);
        setIsCompleteCorrectiveAction(false);
        setIsTakeCorrectiveAction(false);
        setFrequencySelected({ ...frequencySelected, label: "", value: "" });
        setDayOfWeekSelected({ ...dayOfWeekSelected, label: t("page.anyday"), value: 0 });
    }
    function submitRow() {
        setError("");
        setIsSubmit(true);
        let freqSelect = frequencySelected.value;
        let dowSelect = dayOfWeekSelected.value;

        let initialValues = {
            appSurveyKey: appSurveySelected.value,
            notCompleted: notCompletedRef.current.checked,
            completed: completedRef.current.checked,
            highScore: highScoreRef.current.checked,
            takeCorrectiveAction: takeCorrectiveActionRef.current.checked,
            completedCorrectiveAction: completeCorrectiveActionRef.current.checked,
            dayOfWeek: dowSelect,
            weekly: (freqSelect === "week") ? true : false,
            monthly: (freqSelect === "month") ? true : false,
            yearly: (freqSelect === "year") ? true : false,
        };

        if (!appSurveySelected.value || appSurveySelected.value === 0) {
            setError(t("error.appSurveyNameReqd"));
            setIsSubmit(false);
        } else {
            handleSubmit(1, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setIsNotCompleted(false);
        setIsCompleted(false);
        setIsHighScore(false);
        setIsCompleteCorrectiveAction(false);
        setIsTakeCorrectiveAction(false);
        setFrequencySelected({ ...frequencySelected, label: "", value: "" });
        setDayOfWeekSelected({ ...dayOfWeekSelected, label: t("page.anyday"), value: 0 });
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {appSurveyLoaded ? <Select
                    name="appSurveyKey"
                    options={appSurveyOptions}
                    onChange={appSurveyHandler}
                    placeholder={""}
                    value={appSurveySelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="appSurveyKey-input"
                    styles={ddStyles}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <Select
                    ref={freqRef}
                    name="freq"
                    options={frequencyOptions}
                    onChange={freqHandler}
                    placeholder={""}
                    value={frequencySelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="freq-input"
                    styles={ddStyles}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <Select
                    ref={dowRef}
                    name="dow"
                    options={dayOfWeekOptions}
                    onChange={dayOfWeekHandler}
                    placeholder={""}
                    value={dayOfWeekSelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="dow-input"
                    styles={ddStyles}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={notCompletedRef}
                    name={"notCompleted_0"}
                    id={"notCompleted_0"}
                    defaultChecked={true}
                    checked={isNotCompleted}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={completedRef}
                    name={"completed_0"}
                    id={"completed_0"}
                    defaultChecked={true}
                    checked={isCompleted}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={highScoreRef}
                    name={"highScore_0"}
                    id={"highScore_0"}
                    defaultChecked={true}
                    checked={isHighScore}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={takeCorrectiveActionRef}
                    name={"takeCorrectiveAction_0"}
                    id={"takeCorrectiveAction_0"}
                    defaultChecked={false}
                    checked={isTakeCorrectiveAction}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={completeCorrectiveActionRef}
                    name={"completeCorrectiveAction_0"}
                    id={"completeCorrectiveAction_0"}
                    defaultChecked={false}
                    checked={isCompleteCorrectiveAction}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {(appSurveyOptions && appSurveyOptions.length > 0) ?
                    (<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
                    :
                    (<></>)
                }
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
            </td>
        </tr>
    )

}
export default UserAppSurveyAlertTableRow;